import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { messaging, db, auth } from './firebase';

// 🔑 Obtén esta clave en:
// Firebase Console → Project Settings → Cloud Messaging → Web configuration → Generate key pair
const VAPID_KEY = process.env.REACT_APP_VAPID_KEY || '';

export function usePushNotifications() {
  useEffect(() => {
    if (!VAPID_KEY) {
      console.warn('Push notifications: falta REACT_APP_VAPID_KEY en .env');
      return;
    }
    let unsubMessage = null;

    const unsub = onAuthStateChanged(auth, async (user) => {
      // Remove the previous onMessage listener before potentially adding a new one
      if (unsubMessage) { unsubMessage(); unsubMessage = null; }
      if (!user) return;
      if (!('Notification' in window)) return;

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;

      try {
        const token = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (token) {
          await updateDoc(doc(db, 'users', user.uid), { fcmToken: token });
        }

        // onMessage returns an unsubscribe function — store it so we never
        // register more than one listener at a time.
        unsubMessage = onMessage(messaging, (payload) => {
          // Call notifications: the CallProvider Firestore listener already
          // shows the in-app overlay, so skip showing a browser notification.
          if (payload.data?.type === 'call') return;

          // Cloud Function sends data-only payload (no notification field)
          const title = payload.data?.title || payload.notification?.title || 'Chatio';
          const body  = payload.data?.body  || payload.notification?.body  || '';
          if (Notification.permission === 'granted') {
            new Notification(title, { body, icon: '/logo192.png' });
          }
        });
      } catch (err) {
        console.error('FCM setup error:', err);
      }
    });

    return () => {
      unsub();
      if (unsubMessage) unsubMessage();
    };
  }, []);
}
